export default defineNuxtRouteMiddleware(() => {
  const rotasLiberadas = [
    '/autenticacao',
    '/politica-de-privacidade'
  ]

  const currentPath = useRoute().fullPath
  const isRotaLiberada = rotasLiberadas.some(rota => currentPath.includes(rota))

  if (useAutenticacaoStore().retornarToken === '' && !isRotaLiberada) {
    return navigateTo(useApiStore().redirectBackWhenSignedUrl(), {
      external: true,
    })
  }
})
